import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utilities } from '../../shared/utils/utilities';

import { HttpClient } from '@angular/common/http';
import { Observable, map, of, switchMap } from 'rxjs';
import { TrackingService } from './tracking.service';
import { TRACKING } from '../enums/trackingParts.enum';
import { DatadogService } from './datadog.service';

export interface LanguagesConfig {
  acronym: string,
  language: string,
  file: string
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public selectedLanguage: string = 're';
  // Using Three-letter-codes of ISO-639
  public availableLanguages: Array<LanguagesConfig> = [
    { acronym: 'DE', language: 'Deutsch', file: 're' },
    { acronym: 'EN', language: 'English', file: 'eng' }
  ];

  constructor(
    private translateService: TranslateService,
    private trackingService: TrackingService,
    private datadogService: DatadogService,
    private http: HttpClient
  ) { }

  getLanguageSelectionAvailable(): boolean {
    return true;
  }

  setInitialLanguage() {
    const cookieLanguage = Utilities.getCookie('language');
    if (cookieLanguage &&
      // Prevent unknown languages breaking application
      this.availableLanguages.some(config => config.file === cookieLanguage)) {
      this.selectedLanguage = cookieLanguage;
      this.translateService.use(this.selectedLanguage);
    } else {
      const defaultLanguage = 're';
      this.translateService.use(defaultLanguage);
      this.selectedLanguage = defaultLanguage;
    }
    this.trackingService.postSimpleTracking(TRACKING.LOCATION.LANGUAGE_SELECTION, TRACKING.ACTION.SET,
      this.availableLanguages.find(config => config.file === this.selectedLanguage).language);
  }

  setLanguage(newLanguage: string) {
    if (!this.availableLanguages.some(config => config.file === newLanguage)) {
      const route = typeof window !== 'undefined' ? window.location.pathname : 'unknown-route';
      this.datadogService.trackCustomEvent(
        `language_invalid_selection|value:${newLanguage || 'empty'}|route:${route}`
      );
      return;
    }

    this.selectedLanguage = newLanguage;
    this.translateService.use(newLanguage);
    Utilities.createCookie('language', newLanguage, 30);
    this.trackingService.postSimpleTracking(TRACKING.LOCATION.LANGUAGE_SELECTION, TRACKING.ACTION.CLICK,
      this.availableLanguages.find(config => config.file === this.selectedLanguage).language);
  }

  getSelectedLanguage(): string {
    return this.selectedLanguage;
  }

  getKeysFAQinDefaultLang(keyName: string): Observable<Array<string>> {
    // we use default - translation to find how many faqs we will show
    return this.http
      .get('../../../assets/i18n/' + this.translateService.getFallbackLang() + '.json', { responseType: 'text' })
      .pipe(
        map((data) => JSON.parse(data)),
        switchMap((res) => {
          const faqsToKeyNew = keyName.split('.').reduce((a,b) => a[b], res);
          return of(Object.keys(faqsToKeyNew));
        })
      );
  }
}
